const SeoApi = {
    postCreate: '/crud/seo-meta-tags',
    postRobots: '/crud/seo-meta-tags/robots',
    postAction: '/crud/seo-meta-tags/:id/action',

    putUpdate: '/crud/seo-meta-tags/:id',

    deleteDestroy: '/crud/seo-meta-tags/:id',

    getIndex: '/crud/seo-meta-tags',
    getSelect: '/crud/seo-meta-tags/select',
    getType: '/crud/seo-meta-tags/type',
    getRobots: '/crud/seo-meta-tags/robots',
    getId: '/crud/seo-meta-tags/:id',
}

export default SeoApi;
